module.exports = __webpack_public_path__ + "img/Gertrude_logo2.019ce25d.png";